<template>
  <div>
    <div class="ipt-group" :class="{error: $v.form.account.$error}">
      <input type="text"
             v-model.trim="form.account"
             autocomplete="off"
             style="box-shadow: inset 0 0 0 1000px #fff;"
             placeholder="">
      <p class="sub-text" @click="event => focusInput(event)" :class="{'has-text': form.account}">考试账号</p>
      <div class="line" :style="'background:'+$store.state.theme.themeColor"></div>
      <vd-tips path="form.account" class="error-tip"/>
    </div>
    <div class="ipt-group mb60" :class="{error: $v.form.password.$error}">
      <input type="password"
             autocomplete="new-password"
             style="box-shadow: inset 0 0 0 1000px #fff;"
             v-model.trim="form.password"
             placeholder="">
      <p class="sub-text" @click="event => focusInput(event)" :class="{'has-text': form.password}">密码</p>
      <div class="line" :style="'background:'+$store.state.theme.themeColor"></div>
      <vd-tips path="form.password" class="error-tip"/>
    </div>
  </div>
</template>

<script>
import { required, validationMixin } from '@/utils/mixin_validate'
export default {
  mixins: [validationMixin()],
  validations() {
    // 定义检验规则时注意顺序，弹窗模式时将按顺序弹窗
    return {
      form: {
        account: {
          required
        },
        password: {
          required
        }
      }
    }
  },
  validators: {
    // 这里定义错误提示，与validations结构一一对应
    form: {
      account: {
        required: '请输入账号'
      },
      password: {
        required: '请输入密码'
      }
    }
  },
  data () {
    return {
      form: {
        account: '',
        password: ''
      }
    }
  },
  methods: {
    focusInput (event) {
      this.$emit('focusInput', event)
    }
  }
}
</script>
